import React from 'react';
import { useI18n } from '../../lib/i18n';
import { Reveal } from '../ui/Reveal';
import { ShieldCheckIcon, GlobeIcon, PackageIcon, StarIcon } from 'lucide-react';
export function Authority() {
  const {
    t
  } = useI18n();
  const bullets = [{
    icon: GlobeIcon,
    text: t('authBul1')
  }, {
    icon: StarIcon,
    text: t('authBul2')
  }, {
    icon: PackageIcon,
    text: t('authBul3')
  }, {
    icon: ShieldCheckIcon,
    text: t('authBul4')
  }];
  return <section className="py-24 md:py-32 relative border-t border-luxury-taupe/10 bg-luxury-cream" data-id="element-33">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-34">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-35">
          <div data-id="element-36">
            <Reveal data-id="element-37">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-medium text-luxury-charcoal leading-tight mb-8" data-id="element-38">
                {t('authTitle')}
              </h2>
            </Reveal>
            <Reveal delay={100} data-id="element-39">
              <p className="text-lg text-luxury-stone font-light leading-relaxed mb-10" data-id="element-40">
                {t('authBody')}
              </p>
            </Reveal>
            <Reveal delay={200} data-id="element-41">
              <p className="text-xs text-luxury-gold/80 tracking-widest uppercase font-medium" data-id="element-42">
                {t('authMicro')}
              </p>
            </Reveal>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-43">
            {bullets.map((bullet, idx) => <Reveal key={idx} delay={100 * idx} data-id="element-44">
                <div className="bg-luxury-warmgray/50 border border-luxury-taupe/15 p-8 rounded-3xl h-full flex flex-col hover:border-luxury-gold/30 transition-colors duration-500" data-id="element-45">
                  <bullet.icon className="w-8 h-8 text-luxury-gold mb-6 stroke-[1.5]" data-id="element-46" />
                  <p className="text-sm text-luxury-charcoal font-medium leading-relaxed" data-id="element-47">
                    {bullet.text}
                  </p>
                </div>
              </Reveal>)}
          </div>
        </div>
      </div>
    </section>;
}